module.exports = __webpack_public_path__ + "static/img/4.e2f387d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresarial-Fraude-Empleados/4.png
// module id = 62jS
// module chunks = 0